import { useEffect, useState } from 'react';
import NewsletterForm from '../../components/Newsletter/NewsletterForm';

import '../PopUp/PopUp.css'

const PopUp = () =>{

    const[show,setshow] = useState(false);

    useEffect(() => {
        setInterval(() => {
            setshow(true);
        }, 1000)
    },[]);

    // window.addEventListener("load",function(){
        // setInterval(() => {
            
        //     document.querySelector('#close').addEventListener("click", 
            function closeButton() {
                document.querySelector(".popup").style.display = "none";
            }
                
        //         ,
        // 11000) } )
    // )
    //         })
   
    
return(

             <> { show && <div className="popup " data-aos="fade-up" style={{boxShadow: '5px 5px 5px ', marginTop:'window.InnerHeight'}}>
                <div className='row' style={{marginBottom:'20px'}}>
                        <div className='col-4'>
                        </div>
                        <div className='col-4' >
                            <img src='images/imageTrails/Home/biz/I1.png' style={{boxShadow: '5px 5px 5px grey', borderRadius:"50%", width:'100px'}} />
                        </div>
                        <div className='col-4' style={{textAlign:'right'}}>
                            <button id='close' onClick={closeButton} className=' close-btn' ><i  id="btn_hover" className="fa fa-times" aria-hidden="true"></i></button>
                        </div>
                </div>
            <div className="container">

                <div className="row align-items-center">
                    <div className="col-lg-12">
                  
                        <div className="newsletter-content">
                       
                            <div className="" style={{fontSize:'1rem', fontWeight:'700', color:'black',textAlign:'center'}}>Sign up and be the first one to know about our new product launches!</div>
                            
                            <NewsletterForm mailchimpUrl="//devitems.us11.list-manage.com/subscribe/post?u=6bbb9b6f5827bd842d9640c82&amp;id=05d85f18ef" />
                        </div>
                    </div>
                
            </div>

            
        </div>
    </div>}
    </>
);

}

export default PopUp;

